export default __webpack_public_path__ + "static/media/479.3c88780b.gif";